import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, getAdminToken, setAdminToken } from "./adminApi";

const AdminAuthContext = createContext(null);

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}

export default function AdminAuthProvider({ children }) {
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  // При старте: если есть токен — валидируем его через /auth/me/
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const token = getAdminToken();
      if (!token) { setLoading(false); return; }
      try {
        const me = await adminApi.me();
        if (!cancelled) setStaff(me);
      } catch (e) {
        if (!cancelled) { setAdminToken(""); setStaff(null); }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await adminApi.login(email, password);
    setAdminToken(res.token);
    setStaff(res.account);
    return res;
  }, []);

  const logout = useCallback(async () => {
    try { await adminApi.logout(); } catch (e) { /* всё равно чистим локально */ }
    setAdminToken("");
    setStaff(null);
  }, []);

  const value = { staff, setStaff, loading, login, logout };
  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
}